import styled from 'styled-components';

const StyledInput = styled.input`
  border: 0;
  border-radius: 8px;
  background: #27262b;
  width: 100%;
  text-align: center;
  padding: 8px 0;
  box-sizing: border-box;
  -moz-appearance: textfield;
  appearance: textfield;
  font-family: Rubik;
  font-size: 36px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%; /* 43.2px */
  color: ${({ $error }) => ($error ? '#DA4444' : 'inherit')};

  /* Скрыть стрелки в браузерах */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  @media (max-width: 768px) {
    font-size: 28px;
  }
`;

export { StyledInput };
